"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const pin_xxs_svg_1 = __importDefault(require("../../../assets/images/pin-xxs.svg"));
const propertyBackDefault_webp_1 = __importDefault(require("../../../assets/images/propertyBackDefault.webp"));
const DraggableScroll_1 = __importDefault(require("../../../components/dragabbleScroll/DraggableScroll"));
const HeaderSearchForm_1 = __importDefault(require("../../../components/headerSearchForm/HeaderSearchForm"));
const SectionTitle_1 = __importDefault(require("../../../components/sectionTitle/SectionTitle"));
const underline_1 = __importDefault(require("../../../components/underline"));
const RoutesPaths_1 = require("../../../routes/RoutesPaths");
const HomeService_1 = __importDefault(require("../../../services/HomeService"));
const detectDevice_1 = __importDefault(require("../../../utils/detectDevice"));
require("./SectionLocation.scss");
const SectionLocation = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const [suites, setSuites] = (0, react_1.useState)([]);
    const { isMobile } = (0, detectDevice_1.default)();
    const getPropertiesWithPrice = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield HomeService_1.default.loadPropertiesWithPrice();
        setSuites(response);
    }), []);
    const redirectPropertySuite = (0, react_1.useCallback)((propId) => {
        history.push(`${RoutesPaths_1.routesPaths.bookSuite}?property=["${propId}"]`);
    }, [history]);
    (0, react_1.useEffect)(() => {
        getPropertiesWithPrice();
    }, [getPropertiesWithPrice]);
    const getMobileLayout = (0, react_1.useCallback)(() => {
        return (react_1.default.createElement("div", { className: "content-header-mobile" },
            react_1.default.createElement("div", { className: "menu-mobile" },
                react_1.default.createElement("div", { className: "wrapper-mobile" },
                    react_1.default.createElement("img", { src: pin_xxs_svg_1.default, alt: "" }),
                    react_1.default.createElement("span", { className: "bold" }, "S\u00E3o Paulo - SP"))),
            react_1.default.createElement("div", { className: "title-mobile" },
                react_1.default.createElement(SectionTitle_1.default, { text: "Onde estamos localizados?" }),
                react_1.default.createElement(underline_1.default, null))));
    }, []);
    const getDesktopLayout = (0, react_1.useCallback)(() => {
        return (react_1.default.createElement("div", { className: "content-header" },
            react_1.default.createElement("div", { className: "title-group" },
                react_1.default.createElement("div", { className: "title" },
                    react_1.default.createElement("span", null,
                        "Onde estamos",
                        react_1.default.createElement("strong", null, " localizados?")),
                    react_1.default.createElement(underline_1.default, null)),
                react_1.default.createElement("div", { className: "location" },
                    react_1.default.createElement("div", { className: "wrapper" },
                        react_1.default.createElement("img", { src: pin_xxs_svg_1.default, alt: "" }),
                        react_1.default.createElement("span", { className: "bold" }, "S\u00E3o Paulo - SP"))))));
    }, []);
    return (react_1.default.createElement("div", { className: "SectionLocation" },
        react_1.default.createElement(HeaderSearchForm_1.default, null),
        isMobile ? getMobileLayout() : getDesktopLayout(),
        react_1.default.createElement("div", { className: "content-body" },
            react_1.default.createElement("div", { className: "description" },
                react_1.default.createElement("span", { className: "description-text" }, "Estamos espalhados nos pontos mais atrativos de S\u00E3o Paulo."),
                react_1.default.createElement("span", { className: "description-text bold" }, " Conhe\u00E7a as suas op\u00E7\u00F5es de hospedagem.")),
            react_1.default.createElement("div", { className: "fullFlexRelative" },
                react_1.default.createElement(DraggableScroll_1.default, { withArrows: suites.length > 0, itemsLength: suites.length },
                    react_1.default.createElement("div", { style: { display: 'flex' } }, suites.map(suite => (react_1.default.createElement("div", { className: "carousel-card", key: suite.propId },
                        react_1.default.createElement("div", { className: "image-container", onClick: () => redirectPropertySuite(suite.propId) },
                            react_1.default.createElement("img", { draggable: false, src: suite.url[0] ? suite.url[0] : propertyBackDefault_webp_1.default, alt: "suite.text", className: "item-img", loading: "lazy" }),
                            react_1.default.createElement("div", { className: "item-text" },
                                react_1.default.createElement("span", null, suite.name))),
                        react_1.default.createElement("div", { className: "item-informations" },
                            react_1.default.createElement("div", { className: "top-content" },
                                react_1.default.createElement("span", { className: "top-text bold" }, suite.address),
                                react_1.default.createElement("span", { className: "top-text" }, `CEP: ${suite.postcode}`)),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("div", { className: "bot-content-simple" },
                                    react_1.default.createElement("div", { className: "column" },
                                        react_1.default.createElement("span", null, "A partir de "),
                                        react_1.default.createElement("span", { className: "price-text" },
                                            react_1.default.createElement("span", null, "R$"),
                                            react_1.default.createElement("span", null, ` ${suite.price.toFixed(2)}`),
                                            react_1.default.createElement("span", null, "/ di\u00E1ria")))))))))))))));
};
exports.default = SectionLocation;
